module.exports = __webpack_public_path__ + "static/media/AAPL Logo.30c21a9a.jpeg";